export const tableStyles = {
    border: 0,
    "& .MuiDataGrid-columnHeaders": {
        borderBottom: "none",
        gap: "8px",
    },
    "& .MuiDataGrid-columnHeader": {
        backgroundColor: "custom.grey1",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
 
        color: "custom.blue2",
        // textAlign: "center",
        // justifyContent: "center",
        borderRadius: "10px",
        padding: "10px",
        width: "100% !important",
        // alignItems: "center",
        // whiteSpace: "normal",
        fontSize: {
            md: "10px",
            lg: "10px",
            xl: "12px",
        },
        fontWeight: "700",
    },
    "& .MuiDataGrid-row": {
        borderBottom: (theme: any) => `1px solid ${theme.palette.custom.icons}`,
    },
};